import script from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=efddc102&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efddc102"]])

export default __exports__